import React from "react";

import Currency from "../currency/currency.tsx";

import RaindropDivider from "../raindrop-divider/raindrop-divider.js";

import ModelComponentAccountPlanSausage from "../model-component-account-plan-sausage/model-component-account-plan-sausage.js";

import RaindropButton, {
  ButtonStyle,
} from "../raindrop-button/raindrop-button.tsx";
import { fetchAccountPlansExecute } from "../../services/api-raindrop.js";
import { useState } from "react";
import RaindropInput from "../raindrop-input/raindrop-input.tsx";
import ModelComponent from "../model-component/model-component.tsx";

const ModelComponentAccountPlan = ({
  id,
  subunits,
  subunitsCurrency,
  sausages,
  contributionDay,
  isSupportingRaindrop = true,
  rawData,
}) => {
  const [isExecuting, setIsExecuting] = useState(false);

  const onExecute = () => {
    setIsExecuting(true);
    fetchAccountPlansExecute({
      accountPlanId: id,
    }).finally(() => {
      setIsExecuting(false);
    });
  };

  const dropDownComponent = (
    <RaindropButton
      title="Execute"
      onClick={onExecute}
      icon="fa-circle-up"
      style={ButtonStyle.Secondary}
      isLoading={isExecuting}
    />
  );
  return (
    <ModelComponent
      modelId={id}
      colorBorderAccent="dark:border-color-dark-model-account-plan border-color-model-account-plan"
      dropdownComponent={dropDownComponent}
      rawData={rawData}
    >
      <div className="flex flex-col gap-4">
        <Currency
          subunits={subunits}
          currency={subunitsCurrency}
          isMonthly={true}
          isStylised={true}
        />
        <RaindropInput
          label="Contribution Day"
          value={contributionDay}
          isShowLabel={true}
          isEditing={false}
          icon=""
        />

        <RaindropDivider />
        <h4 className="w-full text-left text-color-dark-text-tertiary font-semibold text-xs">
          SAUSAGES
        </h4>
        <div className="flex flex-col gap-2">
          {sausages &&
            sausages.map((sausage) => (
              <ModelComponentAccountPlanSausage
                id={sausage.id}
                organisationId={sausage.organisation}
                organisationLogoUrl={sausage.organisation_logo_url}
                organisationName={sausage.organisation_name}
                percentage={sausage.percentage}
              />
            ))}
          {sausages.length === 0 && (
            <div className="text-color-text-secondary dark:text-color-dark-text-secondary text-sm pb-4">
              No sausages to display
            </div>
          )}
        </div>
      </div>
    </ModelComponent>
  );
};

export default ModelComponentAccountPlan;
